import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "@ploy-lib/rest-resources";
export class EncumberanceCheckResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.application = undefined;
        this.object = undefined;
        this.history = undefined;
        this.fieldVisibility = undefined;
        this.fieldOptions = undefined;
        this.regNoRules = undefined;
        this.regNoSearchResult = undefined;
        this.encumberanceResult = undefined;
        this.titleCheckResult = undefined;
        this.messages = undefined;
        this.mismatch = undefined;
        this.mustReplace = undefined;
    }
    pk() {
        return this.application?.applicationId?.toString();
    }
    static baseUrl(applicationId) {
        return this.urlRoot.replace("{applicationId}", String(applicationId));
    }
    static searchEndpoint(path, paramName) {
        return this.detail().extend({
            schema: undefined,
            url: (params) => `${this.baseUrl(params.applicationId)}/${path}/${params[paramName]}`
        });
    }
    static actionEndpoint(path) {
        return this.create().extend({
            schema: undefined,
            url: ({ applicationId }) => `${this.baseUrl(applicationId)}/${path}`
        });
    }
    static searchByRegNo() {
        return this.searchEndpoint("search/registration-number", "regNo");
    }
    static searchByChassisNo() {
        return this.searchEndpoint("search/chassis-number", "chassisNo");
    }
    static checkEncumberance() {
        return this.actionEndpoint("check");
    }
    static titleCheck() {
        return this.actionEndpoint("title-check");
    }
    static save() {
        return this.actionEndpoint("save");
    }
}
EncumberanceCheckResource.urlRoot = `${apiResourceUrl("encumberance-check")}/{applicationId}`;
EncumberanceCheckResource.urlTemplates = [`${EncumberanceCheckResource.urlRoot}/current-object`];
//# sourceMappingURL=EncumberanceCheckResource.js.map